<span *ngIf="cellValue >= 0 && cellValue != null" class="neutral-dollar">
  {{ (cellValue | number: '1.0-2') + '%' || '-' }}
</span>
<span *ngIf="cellValue < 0 && cellValue != null" class="negative-dollar">
  <span>(</span>{{ cellValue < 0 && cellValue != null ? (cellValue | number: '1.0-2') + '%' + ')' : '-' }}
</span>

<span *ngIf="cellValue == null">{{ '-' }}</span>
